import { useEffect } from 'react';

export const usePageTitle = (title: string) => {
  useEffect(() => {
    const baseTitle = 'Chintan Tank';
    document.title = `${baseTitle} | ${title}`;

    return () => {
      document.title = baseTitle;
    };
  }, [title]);
};